(function (window, $) {
    'use strict';

    // store last opener per modal element
    var lastTrigger = new WeakMap();

    // capture opener (works for data-api opens; also ok to set manually)
    $(document).on('show.bs.modal', '.modal', function (e) {
        if (e && e.relatedTarget) lastTrigger.set(this, e.relatedTarget);
    });

    function moveFocusOut(modalEl) {
        var active = document.activeElement;

        if (active && modalEl.contains(active)) {
            // Prefer returning focus to the opener if we have it
            var trigger = lastTrigger.get(modalEl);

            if (trigger && typeof trigger.focus === 'function' && document.contains(trigger)) {
                trigger.focus();
                return;
            }

            // Fallback: focus body (temporarily tabbable)
            document.body.setAttribute('tabindex', '-1');
            document.body.focus();
            setTimeout(function () {
                document.body.removeAttribute('tabindex');
            }, 0);
        }
    }

    function patchModalPrototype(Proto) {
        if (!Proto || !Proto._hideModal || Proto._hideModal.__prodigyA11yPatched) return;

        var original = Proto._hideModal;

        Proto._hideModal = function () {
            // THIS runs right before Bootstrap sets aria-hidden="true"
            moveFocusOut(this._element || this._dialog || this._backdrop || this._element);

            return original.apply(this, arguments);
        };

        Proto._hideModal.__prodigyA11yPatched = true;
    }

    // Bootstrap 5
    if (window.bootstrap && window.bootstrap.Modal && window.bootstrap.Modal.prototype) {
        patchModalPrototype(window.bootstrap.Modal.prototype);
    }

    // Bootstrap 4 (jQuery plugin)
    if ($ && $.fn && $.fn.modal && $.fn.modal.Constructor && $.fn.modal.Constructor.prototype) {
        patchModalPrototype($.fn.modal.Constructor.prototype);
    }
})(window, window.jQuery);
